import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { Button } from "@mui/material";

const HSCodesDeleteDialog = ({ handleDelete, HSCodesDelete, setHSCodesDelete }) => {
  return (
    <Dialog
      open={HSCodesDelete}
      onClose={() => setHSCodesDelete(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">HS Kodu Silme Onayı</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Bu HS kodunu silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setHSCodesDelete(false)} className="iyzi-button-blue">
          İptal
        </Button>
        <Button onClick={handleDelete} className="iyzi-button-red" autoFocus>
          Sil
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HSCodesDeleteDialog;
